import { render, staticRenderFns } from "./zpgw.vue?vue&type=template&id=3b2668d1&scoped=true&"
import script from "./zpgw.vue?vue&type=script&lang=js&"
export * from "./zpgw.vue?vue&type=script&lang=js&"
import style0 from "./zpgw.vue?vue&type=style&index=0&id=3b2668d1&scoped=true&lang=css&"
import style1 from "./zpgw.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2668d1",
  null
  
)

export default component.exports